export const GET_JOB_DETAILS = "/api/jobfeed/v5/jobs/{jobId}"
export const GET_ASSESSMENT = "/api/assessments/v1/web/jobs/{jobId}/"
export const EVAL_ASSESSMENT = "/api/assessments/v1/web/jobs/{jobId}/"
export const APPLIED_JOBS = "/api/v2/applied-jobs/"
export const GET_SCREEN_DETAILS = "/api/jobfeed/v1/ecc/get_screen_details/?job_id={jobId}"
